import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PriceAlert } from '../../types/entities';

import { PriceAlertState, initialPriceAlertState } from './state';

const openOrderSlice = createSlice({
  name: 'price-alert',
  initialState: initialPriceAlertState,
  reducers: {
    reset: () => initialPriceAlertState,
    loading: (state: PriceAlertState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = action.payload;
      state.loaded = !action.payload;
      state.pending = false;
    },
    pending: (state: PriceAlertState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.pending = action.payload;
    },
    success: (state: PriceAlertState, action: PayloadAction<PriceAlert[]>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.pending = false;
      state.priceAlerts = action.payload;
    },
    clearing: (state: PriceAlertState, action: PayloadAction<boolean>) => {
      state.error = undefined;
      state.loading = false;
      state.loaded = true;
      state.clearing = action.payload;
    },
    removeAll: (state: PriceAlertState) => {
      state.error = undefined;
      state.clearing = false;
      state.priceAlerts = [];
    },
    fail: (state: PriceAlertState, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.loaded = true;
      state.pending = false;
      state.clearing = false;
      state.priceAlerts = [];
    }
  }
});

const { actions, reducer } = openOrderSlice;
export const { reset, loading, success, fail, pending, clearing, removeAll } = actions;
export default reducer;
